namespace GeniuzPOS.Member {
    export interface MbReport02_Row {
        MbId?: string;
        MbType?: string;
        MbNameT?: string;
        MbNameE?: string;
        MbAddress?: string;
        MbProvince?: string;
        MbAmphur?: string;
        MbTumbol?: string;
        MbZipCode?: string;
        MbPid?: string;
        MbTelNo?: string;
        MbEmail?: string;
        MbGender?: string;
        MbNation?: string;
        MbRace?: string;
        MbOccupation?: string;
        MbBirthDay?: string;
        MbCardType?: string;
        MbApplyDate?: string;
        MbExpireDate?: string;
        MbCardStatus?: number;
        MbPhoto?: string;
        MbAccumPoint?: number;
        MbNearlyExpirePoint?: number;
        MbExpirePointDate?: string;
        MbMemo?: string;
        UpdateBy?: string;
        LastUpdate?: string;
    }

    export namespace MbReport02_Row {
        export const idProperty = 'MbId';
        export const nameProperty = 'MbId';
        export const localTextPrefix = 'Member.MbReport02_';
        export const deletePermission = '3Member:การจัดการวันหมดอายุสมาชิก:Modify';
        export const insertPermission = '3Member:การจัดการวันหมดอายุสมาชิก:Modify';
        export const readPermission = '3Member:การจัดการวันหมดอายุสมาชิก:View';
        export const updatePermission = '3Member:การจัดการวันหมดอายุสมาชิก:Modify';

        export declare const enum Fields {
            MbId = "MbId",
            MbType = "MbType",
            MbNameT = "MbNameT",
            MbNameE = "MbNameE",
            MbAddress = "MbAddress",
            MbProvince = "MbProvince",
            MbAmphur = "MbAmphur",
            MbTumbol = "MbTumbol",
            MbZipCode = "MbZipCode",
            MbPid = "MbPid",
            MbTelNo = "MbTelNo",
            MbEmail = "MbEmail",
            MbGender = "MbGender",
            MbNation = "MbNation",
            MbRace = "MbRace",
            MbOccupation = "MbOccupation",
            MbBirthDay = "MbBirthDay",
            MbCardType = "MbCardType",
            MbApplyDate = "MbApplyDate",
            MbExpireDate = "MbExpireDate",
            MbCardStatus = "MbCardStatus",
            MbPhoto = "MbPhoto",
            MbAccumPoint = "MbAccumPoint",
            MbNearlyExpirePoint = "MbNearlyExpirePoint",
            MbExpirePointDate = "MbExpirePointDate",
            MbMemo = "MbMemo",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate"
        }
    }
}
